import { defineStore } from 'pinia'
import { store } from '../index'
import { useI18n } from '@/hooks/web/useI18n'

export const useProductStore = defineStore('product', {
  state: (): { [key: string]: any } => {
    return {
      cateFirst: [], // 一级分类
      cateSecond: [], // 二级分类
      styleAll: [], // 所有样式
      model: null, // 模型
      position: null, // 摆放限制
      save_product_id: undefined, // 保存sku时product id
      productInfo: null, // 编辑产品信息
      status: null, // 产品的状态
      type: null // 产品的类型
    }
  },
  getters: {
    getCateFirst(): { [key: string]: any } | undefined {
      return this.cateFirst
    },
    getCateSecond(): { [key: string]: any } | undefined {
      return this.cateSecond
    },
    getStyleAll(): { [key: string]: any } | undefined {
      return this.styleAll
    },
    getProductId(): Number | undefined {
      return this.save_product_id
    },
    getPosition(): any {
      const { t } = useI18n()
      if (!this.position) {
        this.position = [
          { value: 1, label: t('product.stickGround') },
          { value: 2, label: t('product.stickWall') },
          { value: 3, label: t('product.stickRoof') },
          { value: 4, label: t('product.stickProduct') }
        ]
      }
      return this.position
    },
    getModel(): any {
      const { t } = useI18n()
      if (!this.model) {
        this.model = [
          { value: 1, label: t('product.stickGround') },
          { value: 2, label: t('product.stickWall') },
          { value: 3, label: t('product.stickRoof') },
          { value: 4, label: t('product.stickProduct') }
        ]
      }
      return this.model
    },
    getStatus(): any {
      const { t } = useI18n()
      if (!this.status) {
        this.status = [
          { value: 1, label: t('product.public') },
          { value: 2, label: t('product.password') },
          { value: 3, label: t('product.forbidden') }
        ]
      }
      return this.status
    },
    getType(): any {
      const { t } = useI18n()
      if (!this.type) {
        this.type = [
          { value: 1, label: t('product.sculpture') },
          { value: 2, label: t('product.drawing') }
        ]
      }
      return this.type
    },
    getProductInfo(): { [key: string]: string } | null {
      return this.productInfo
    }
  },
  actions: {
    clearProductStore() {
      this.cateFirst = []
      this.cateSecond = []
      this.styleAll = []
      this.save_product_id = undefined
      this.productInfo = null
    },
    setCateFirst(cateFirst: { [key: string]: any } | undefined) {
      this.cateFirst = cateFirst
    },
    setCateSecond(cateSecond: { [key: string]: any } | undefined) {
      this.cateSecond = cateSecond
    },
    setStyleAll(styleAll: { [key: string]: any } | undefined) {
      this.styleAll = styleAll
    },
    setProductId(save_product_id: Number | undefined) {
      this.save_product_id = save_product_id
    },
    setProductInfo(productInfo: { [key: string]: string } | null) {
      this.productInfo = productInfo
    }
  }
})

export const useProductStoreWithOut = () => {
  return useProductStore(store)
}
